import React, { ReactNode } from 'react';

import { ReactComponent as Home3 } from '@portals/icons/linear/home-3.svg';
import {
  CanAccessRouteFn,
  HubType,
  PartnerConfigurationType,
  TenantType,
} from '@portals/types';

type HubsListItemType =
  | {
      hubType: HubType;
      icon?: ReactNode;
      label?: undefined;
      canAccessRoute?: CanAccessRouteFn<PartnerConfigurationType>;
    }
  | {
      hubType: HubType;
      icon?: undefined;
      label: string;
      canAccessRoute?: CanAccessRouteFn<PartnerConfigurationType>;
    };

export const HUBS_LIST: Array<HubsListItemType> = [
  {
    hubType: HubType.Home,
    icon: <Home3 />,
  },
  {
    hubType: HubType.Products,
    label: 'Products',
    canAccessRoute: ({ hasSupportSeat, canView }) =>
      hasSupportSeat || canView(['models', 'fulfillment']),
  },
  {
    hubType: HubType.Ecommerce,
    label: 'eCommerce',
    canAccessRoute: ({ hasSupportSeat, canView }) =>
      hasSupportSeat || canView(['store_management', 'finance', 'fulfillment']),
  },
  {
    hubType: HubType.Operations,
    label: 'Operations',
    canAccessRoute: ({ canView, configuration }) =>
      configuration?.pricing_plan?.features?.store === 1 &&
      canView(['finance', 'fulfillment']),
  },
  {
    hubType: HubType.Finance,
    label: 'Finance',
    canAccessRoute: ({ canView }) => canView(['finance', 'fulfillment']),
  },
  {
    hubType: HubType.Support,
    label: 'Support',
    canAccessRoute: ({ hasSupportSeat, isAdmin, configuration }) =>
      isAdmin ||
      (hasSupportSeat &&
        Boolean(configuration?.portal_capabilities?.support_center)),
  },
  {
    hubType: HubType.Marketing,
    label: 'Marketing',
    canAccessRoute: ({ isAdmin, configuration }) =>
      isAdmin &&
      configuration?.[TenantType.Partner]?.classification !== 'channel_partner',
  },
];
